import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import env from '../enviorments'
import header from '../header'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        token: null,
        user: null,
        item: [],
        cartCount: null
    },
    getters: {
        getCart: state => {
            return state.cartCount;
        }
    },
    mutations: {
        mutateUser(state, user) {
            state.user = user
        },
        mutateToken(state, token) {
            state.token = token
        },
        increment (state) {
            const itemCount = JSON.parse(window.localStorage.getItem('cart'))
            if(itemCount){
                state.cartCount = itemCount.length
            }else{
                state.cartCount = 0
            }
        },
        mutateCount(state){
            const itemCount = JSON.parse(window.localStorage.getItem('cart'))
            if(itemCount){
                state.cartCount = itemCount.length
            }else{
                state.cartCount = 0
            }

            return state.cartCount
        }
    },
    actions: {
        async userLogin({commit}, user) {
            const result = (await axios.post(env.apiUrl + 'consumer-user-login', {...user})).data
            if (result.status == 'fail') return {"status": "fail", "data": [], "message": result.message, "error": []}
            window.localStorage.setItem('token', JSON.stringify(result.data.token))
            result.data.password = null,
            window.localStorage.setItem('user', JSON.stringify(result.data))
            commit('mutateToken', result.token)
            commit('mutateUser', result.data)
            return {"status": "success", "data": result.data, "message": "Success", "error": []}
        },
        async smsVeirfyAction({commit}, data) {
            const result = (await axios.post(env.apiUrl + 'sms-verify', {...data}, {headers: header.getToken()})).data
            if (result.status == 'fail') return {"status": "fail", "data": [], "message": result.message, "error": []}
            return {"status": "success", "data": result.data, "message": "Success", "error": []}
        },
        async registerAction({commit}, data) {
            const result = (await axios.post(env.apiUrl + 'consumer-register', {...data}, {headers: header.getToken()})).data
            if (result.status == 'fail') return {"status": "fail", "data": [], "message": result.message, "error": []}
            window.localStorage.setItem('token', JSON.stringify(result.data.token))
            result.data.password = null,
            window.localStorage.setItem('user', JSON.stringify(result.data))
            commit('mutateToken', result.token)
            commit('mutateUser', result.data)
            return {"status": "success", "data": result.data, "message": "Success", "error": []}
        },
        async forgotVeirfyAction({commit}, data) {
            const result = (await axios.post(env.apiUrl + 'forgot-verify', {...data}, {headers: header.getToken()})).data
            if (result.status == 'fail') return {"status": "fail", "data": [], "message": result.message, "error": []}
            return {"status": "success", "data": result.data, "message": "Success", "error": []}
        },
        async otpVeirfyAction({commit}, data) {
            const result = (await axios.post(env.apiUrl + 'otp-verify', {...data}, {headers: header.getToken()})).data
            if (result.status == 'fail') return {"status": "fail", "data": [], "message": result.message, "error": []}
            return {"status": "success", "data": result.data, "message": "Success", "error": []}
        },
        async resetPasswordAction({commit}, data) {
            const result = (await axios.post(env.apiUrl + 'reset-password', {...data}, {headers: header.getToken()})).data
            if (result.status == 'fail') return {"status": "fail", "data": [], "message": result.message, "error": []}
            return {"status": "success", "data": result.data, "message": "Success", "error": []}
        },
        async homeAction({commit}) {
            const result = (await axios.get(env.apiUrl + 'home', {headers: header.getToken()})).data
            if (result.status == 'fail') return {"status": "fail", "data": [], "message": result.message, "error": []}
            return {"status": "success", "data": result.data, "message": "Success", "error": []}
        },
        async orderListAction({commit}) {
            const result = (await axios.get(env.apiUrl + 'order-list', {headers: header.getToken()})).data
            if (result.status == 'fail') return {"status": "fail", "data": [], "message": result.message, "error": []}
            return {"status": "success", "data": result.data, "message": "Success", "error": []}
        },
        async distriOrderHistoryListAction({commit}) {
            const result = (await axios.get(env.apiUrl + 'distri-order-history-list', {headers: header.getToken()})).data
            if (result.status == 'fail') return {"status": "fail", "data": [], "message": result.message, "error": []}
            return {"status": "success", "data": result.data, "message": "Success", "error": []}
        },
        async factoryOrderHistoryListAction({commit}) {
            const result = (await axios.get(env.apiUrl + 'factory-order-history-list', {headers: header.getToken()})).data
            if (result.status == 'fail') return {"status": "fail", "data": [], "message": result.message, "error": []}
            return {"status": "success", "data": result.data, "message": "Success", "error": []}
        },
        async ReturnListAction({commit}) {
            const result = (await axios.get(env.apiUrl + 'return-list', {headers: header.getToken()})).data
            if (result.status == 'fail') return {"status": "fail", "data": [], "message": result.message, "error": []}
            return {"status": "success", "data": result.data, "message": "Success", "error": []}
        },
        async statusChangeAction({commit}, order) {
            const result = (await axios.post(env.apiUrl + 'status-change', {...order}, {headers: header.getToken()})).data
            if (result.status == 'fail') return {"status": "fail", "data": [], "message": result.message, "error": []}
            return {"status": "success", "data": result.data, "message": "Success", "error": []}
        },
        async distributorListAction({commit}) {
            const result = (await axios.get(env.apiUrl + 'distributor-list', {headers: header.getToken()})).data
            if (result.status == 'fail') return {"status": "fail", "data": [], "message": result.message, "error": []}
            return {"status": "success", "data": result.data, "message": "Success", "error": []}
        },
        async orderingAction({commit}, data) {
            const result = (await axios.post(env.apiUrl + 'ordering', {...data}, {headers: header.getToken()})).data
            if (result.status == 'fail') return {"status": "fail", "data": [], "message": result.message, "error": []}
            return {"status": "success", "data": result.data, "message": "Success", "error": []}
        },
        async orderingFactoryAction({commit}, data) {
            const result = (await axios.post(env.apiUrl + 'ordering-factory', {...data}, {headers: header.getToken()})).data
            if (result.status == 'fail') return {"status": "fail", "data": [], "message": result.message, "error": []}
            return {"status": "success", "data": result.data, "message": "Success", "error": []}
        },
        async profileAction({commit}) {
            const result = (await axios.get(env.apiUrl + 'profile', {headers: header.getToken()})).data
            if (result.status == 'fail') return {"status": "fail", "data": [], "message": result.message, "error": []}
            return {"status": "success", "data": result.data, "message": "Success", "error": []}
        },
        async profileChangeAction({commit}, data) {
            const result = (await axios.post(env.apiUrl + 'profile-change', {...data}, {headers: header.getToken()})).data
            if (result.status == 'fail') return {"status": "fail", "data": [], "message": result.message, "error": []}
            return {"status": "success", "data": result.data, "message": "Success", "error": []}
        },
    },
    modules: {
    }
})
